<script>
  import { Link } from "../stores.js";
</script>

<footer class="layout__footer layout-footer">
    <div class="layout-footer__nav">
        <a class="layout-footer__menu" href="/#/guide/agreement">이용약관</a>
        <a class="layout-footer__menu" href="/#/guide/policy">개인정보처리방침</a>
        <a class="layout-footer__menu" href="/#/guide/email-collection-refuse">이메일주소무단수집거부</a>
        <a class="layout-footer__tel" href="tel://1577-0138">창업문의 TEL : 1577-0138</a>
        <a class="layout-footer__top" href="#" on:click|preventDefault="{() => window.scrollTo(0, 0)}">TOP</a>
    </div>
    <div class="layout-footer__line"></div>
    <div class="layout-footer__info-group">
        <h2 class="layout-footer__logo">COFFEE MENTORS</h2>
        <dl class="layout-footer__info">
            <dd class="layout-footer__info-company">(주)공간몬스터</dd>
            <dt class="layout-footer__info-title">대표자 : </dt>
            <dd class="layout-footer__info-text" title="대표자">김지수</dd>
        </dl>
        <dl class="layout-footer__info">
            <dt class="layout-footer__info-title">사업자등록번호 : </dt>
            <dd class="layout-footer__info-text" title="사업자등록번호">893-86-00935</dd>
            <dt class="layout-footer__info-title">FAX : </dt>
            <dd class="layout-footer__info-text" title="FAX">(051) 583-1012</dd>
            <dt class="layout-footer__info-title">E-Mail : </dt>
            <dd class="layout-footer__info-text layout-footer__info-email" title="E-Mail">mentors8272@naver.com</dd>
        </dl>
        <dl class="layout-footer__info">
            <dt class="layout-footer__info-title">북부사업부 : </dt>
            <dd class="layout-footer__info-text" title="북부사업부">서울 양천구 목동로25길 8, B1F ~ B4F</dd>
            <dt class="layout-footer__info-title">남부사업부 : </dt>
            <dd class="layout-footer__info-text layout-footer__info-addr" title="남부사업부">
                부산광역시 해운대구 센텀중앙로 97
                <span class="_newline" />
                센텀스카이비즈 A동 909호
            </dd>
        </dl>
        <div class="layout-footer__copyright">Copyright &copy; 2022 SPACE MONSTER Inc.<span class="_newline"></span> All rights reserved.</div>
        <div class="layout-footer__social-group">
            <a class="layout-footer__social" data="instagram" href="{$Link.instagram}" target="_blank">인스타그램</a>
            <a class="layout-footer__social" data="blog" href="{$Link.blog}" target="_blank">블로그</a>
            <a class="layout-footer__social" data="global" href="{$Link.mentors}" target="_blank">홈페이지</a>
        </div>
    </div>
</footer>

<style>
.layout-footer {
    height: 310px;
}

.layout-footer__nav {
    display: flex;
    align-items: center;
    margin: 0 auto;
    width: 100%;
    max-width: 1280px;
    height: 90px;
    font-size: 87.5%;
    line-height: 100%;
}

.layout-footer__menu {
    position: relative;
    display: inline-block;
    padding: 12px;
    text-decoration: none;
    color: var(--tertiary);
}

.layout-footer__menu:before {
    position: absolute;
    top: calc(50% - 1px);
    left: -1px;
    display: block;
    content: '';
    width: 2px;
    height: 2px;
    border-radius: 50%;
    background: var(--tertiary);
}

.layout-footer__menu:first-child:before {
    content: inherit;
    display: none;
}

.layout-footer__tel {
    position: relative;
    display: inline-block;
    padding: 12px 12px 12px 24px;
    text-decoration: none;
    color: var(--primary);
    font-weight: 700;
}

.layout-footer__top {
    position: relative;
    display: inline-block;
    padding: 12px 16px 12px 12px;
    text-decoration: none;
    color: var(--primary);
    font-weight: 700;
    margin-left: auto;
}

.layout-footer__top:after {
    display: inline-block;
    content: '';
    width: 11px;
    height: 11px;
    box-sizing: border-box;
    border-top: solid 2px var(--primary);
    border-right: solid 0 transparent;
    border-bottom: solid 0 transparent;
    border-left: solid 2px var(--primary);
    transform: translate(10px, 4px) rotate(45deg);
}

.layout-footer__line {
    display: block;
    font-size: 0;
    width: 100%;
    line-height: 0;
    height: 2px;
    background: var(--primary);
}

.layout-footer__info-group {
    position: relative;
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 30px 0 30px 230px;
    box-sizing: border-box;
    overflow: hidden;
}

.layout-footer__logo {
    position: absolute;
    top: 50%;
    left: max(calc(env(safe-area-inset-left) - 8px), 16px);
    display: block;
    width: calc(200px - max(calc(env(safe-area-inset-left) - 8px), 16px));
    height: 130px;
    background: var(--logo-black) no-repeat center center;
    font-size: 0;
    color: transparent;
    transform: translate(0%, -50%);
}

.layout-footer__info {
    display: flex;
    flex-flow: row nowrap;
    font-size: 87.5%;
    line-height: 1;
    padding: 0;
    align-items: center;
}

.layout-footer__info-company {
    position: relative;
    padding: 0 20px;
    line-height: 200%;
    font-weight: 700;
}

.layout-footer__info-title {
    display: none;
    /*position: relative;*/
    /*padding: 0 0 0 20px;*/
}

.layout-footer__info-title:before {
    position: absolute;
    top: 50%;
    left: 0%;
    content: '';
    width: 1px;
    height: 13px;
    background: #B8B8B8;
    transform: translate(0%, -50%);
}

.layout-footer__info-title:first-child {
    padding: 0;
}

.layout-footer__info-title:first-child:before {
    content: inherit;
    display: none;
}

.layout-footer__info-text:after {
    position: absolute;
    top: 50%;
    left: 0%;
    content: '';
    width: 1px;
    height: 13px;
    background: #B8B8B8;
    transform: translate(0%, -50%);
}
.layout-footer__info-text:first-of-type:after {
    content: inherit;
    display: none;
}
.layout-footer__info-text:before{
    content: attr(title)' : ';
}

.layout-footer__info-text {
    position: relative;
    line-height: 140%;
    padding: 0 20px;
    word-break: break-word;
}

.layout-footer__copyright {
    padding: 0 20px;
    font-size: 87.5%;
    color: #818181;
    font-weight: 300;
    line-height: 200%;
    box-sizing: border-box;
}

.layout-footer__social-group {
    position: absolute;
    top: 40px;
    right: 0;
    display: flex;
    gap: 16px;
}

.layout-footer__social {
    display: block;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    text-decoration: none;
    font-size: 0%;
    color: transparent;
    background-color: var(--primary);
    background-size: inherit;
    background-repeat: no-repeat;
}

.layout-footer__social:hover {
    text-decoration: none;
    color: transparent;
}

.layout-footer__social[data="instagram"] {
    background-image: var(--icon-social-instagram);
}

.layout-footer__social[data="blog"] {
    background-image: var(--icon-social-blog);
}

.layout-footer__social[data="global"] {
    background-image: var(--icon-social-global);
}

@media screen and (max-width: 900px) {
  .layout-footer__nav {
    position: relative;
    padding-top: 35px;
    font-size: 87.5%;
    width: fit-content;
    height: 85px;
  }

  .layout-footer__tel {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    text-align: center;
    padding: 16px 12px 12px 12px;
    line-height: 16px;
    box-sizing: border-box;
  }

  .layout-footer__menu {
    padding: 12px 12px 16px 12px;
  }

  .layout-footer__top {
    display: none;
  }

  .layout-footer__logo {
    left: 50%;
    top: 0%;
    transform: translate(-50%, 0%);
    height: 90px;
  }

  .layout-footer__info-group {
    padding: 100px 0px 30px 0px;
  }

  .layout-footer__info {
    justify-content: center;
    flex-wrap: wrap;
    font-size: 87.5%;
  }

  .layout-footer__info-company,
  .layout-footer__info-text {
    padding: 4px 10px;
    line-height: 20px;
    text-align: center;
  }
  .layout-footer__info-text[title="사업자등록번호"]:before{
    content: '사업자번호 : ';
  }

  .layout-footer__info-addr:after,
  .layout-footer__info-email:after {
    display: none;
    content: inherit;
  }
  .layout-footer__info-email {

  }

  .layout-footer__copyright {
    padding: 20px 0;
    font-size: 87.5%;
    text-align: center;
    height: inherit;
  }

  .layout-footer__social-group {
    position: relative;
    top: inherit;
    right: inherit;
    justify-content: center;
  }
}
</style>
